import { ReactNode } from "react";

export enum ActionButtonsType {
    TEST_CONNECTION = "TEST_CONNECTION",
    SIGNIN_WITH_OAUTH = "SIGNIN_WITH_OAUTH",
    TEST_PRIMARY_CONNECTION = "TEST_PRIMARY_CONNECTION"
}
enum Parameters_typeType {
    SPREAD = "SPREAD",
    MAP = "MAP",
    PATH = "PATH"
}

export interface PropertyActionButtonType {
    adapterName: string;
    endpoint: string;
    group: string;
    name: ActionButtonsType;
    parameters: Array<string>;
    parameters_type: Parameters_typeType;
    path: string;
    viewWeight: number;
    visibility: string;
}

export interface PropertryTemplateFieldProps {
    disabled?: boolean;
    label?: string;
    name?: string;
    onChange?: (value: any) => void;
    value?: any;
    error?: boolean;
    placeholder?: string;
    errorText?: string;
    required?: boolean;
    group?: string;
    viewWeight?: number;
    visbility: string;
    type: string;
    component?: ReactNode;
    isActionBtn: boolean;
}
